<section class="co-form u-bg2">
  <div class="c-wrapper--small">
    @switch (mode()) {
      @case ('loading') {
      <div>読込中...</div>
      }
      @case ('form') {
        @for (section of formData()!.sections; track $index) {
        <app-tab-section [section]="section" [element]="element"></app-tab-section>
        }
      }
      @case ('complete') {
      <quill-view-html [content]="formData()!.completeContent" />
      }
    }
  </div>
  @if (mode() === 'form') {
    <div class="u-text-center">
      <div class="co-form__privacy">
        <span class="mwform-checkbox-field horizontal-item">
          <label>
            <input type="checkbox" name="terms" [(ngModel)]="termsCheck" />
            <span class="mwform-checkbox-field-text">ー</span>
          </label>
        </span>
        <a>利用規約・プライバシーポリシー</a>に同意の上
      </div>
      @if (showMatError()) {
        <mat-error>利用規約・プライバシーに同意してください</mat-error>
      }
      <p>
        <button type="button" class="co-form__btn u-br-normal" (click)="send()">無料プラン診断する</button>
      </p>
    </div>
  }
</section>
